(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tabs')) {
    class CollectionTabs extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.addEventListener('click', (event) => {
          const swatch = event.target.closest('.cbt-swatch');
          if (swatch && this.contains(swatch)) {
            event.preventDefault();
            event.stopPropagation();
            this.chooseSwatch(swatch);
            return;
          }
          const tab = event.target.closest('[role="tab"]');
          if (tab && this.contains(tab)) this.select(tab);
        });

        this.addEventListener('keydown', (event) => this.onKeydown(event));

        // Anteprima colore: passaggio del mouse (solo con mouse) e focus da tastiera
        this.addEventListener('pointerover', (event) => {
          if (event.pointerType !== 'mouse') return;
          const swatch = event.target.closest('.cbt-swatch');
          if (swatch) this.previewSwatch(swatch);
        });
        this.addEventListener('pointerout', (event) => {
          if (event.pointerType !== 'mouse') return;
          const list = event.target.closest('.cbt-swatches');
          if (list && !list.contains(event.relatedTarget)) this.restoreCard(list.closest('.cbt-card'));
        });
        this.addEventListener('focusin', (event) => {
          const swatch = event.target.closest('.cbt-swatch');
          if (swatch) this.previewSwatch(swatch);
        });
        this.addEventListener('focusout', (event) => {
          const list = event.target.closest('.cbt-swatches');
          if (list && !list.contains(event.relatedTarget)) this.restoreCard(list.closest('.cbt-card'));
        });

        // Nel theme editor: selezionando il blocco si apre la scheda corrispondente
        this.addEventListener('shopify:block:select', (event) => {
          const tab = this.querySelector('[data-block-id="' + event.detail.blockId + '"]');
          if (tab) this.select(tab, { instant: true });
        });
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[role="tab"]'));
      }

      /* ---------- Campioni colore ---------- */
      mainImage(card) {
        return card.querySelector('.cbt-card__img:not(.cbt-card__img--hover)');
      }

      setImage(card, src, srcset) {
        const img = this.mainImage(card);
        if (!img || !src) return;
        if (!img.dataset.origSrc) {
          img.dataset.origSrc = img.getAttribute('src') || '';
          img.dataset.origSrcset = img.getAttribute('srcset') || '';
        }
        if (srcset) img.setAttribute('srcset', srcset);
        else img.removeAttribute('srcset');
        img.setAttribute('src', src);
        card.classList.add('is-swatch-active');
      }

      previewSwatch(swatch) {
        const card = swatch.closest('.cbt-card');
        if (card && swatch.dataset.src) this.setImage(card, swatch.dataset.src, swatch.dataset.srcset);
      }

      restoreCard(card) {
        if (!card) return;
        const selected = card.querySelector('.cbt-swatch[aria-pressed="true"]');
        if (selected && selected.dataset.src) {
          this.setImage(card, selected.dataset.src, selected.dataset.srcset);
          return;
        }
        const img = this.mainImage(card);
        if (img && img.dataset.origSrc) {
          if (img.dataset.origSrcset) img.setAttribute('srcset', img.dataset.origSrcset);
          else img.removeAttribute('srcset');
          img.setAttribute('src', img.dataset.origSrc);
        }
        card.classList.remove('is-swatch-active');
      }

      chooseSwatch(swatch) {
        const card = swatch.closest('.cbt-card');
        if (!card) return;

        const wasSelected = swatch.getAttribute('aria-pressed') === 'true';
        card.querySelectorAll('.cbt-swatch').forEach((s) => s.setAttribute('aria-pressed', 'false'));
        if (!wasSelected) swatch.setAttribute('aria-pressed', 'true');

        // Il link del prodotto apre la scheda già sul colore scelto
        card.querySelectorAll('.cbt-card__title a').forEach((a) => {
          const base = a.dataset.baseHref || a.getAttribute('href');
          a.dataset.baseHref = base;
          a.setAttribute(
            'href',
            !wasSelected && swatch.dataset.variantId ? base + '?variant=' + swatch.dataset.variantId : base
          );
        });

        if (wasSelected) this.restoreCard(card);
        else this.previewSwatch(swatch);
      }

      /* ---------- Tab ---------- */
      select(tab, { focus = false, instant = false } = {}) {
        const panelId = tab.getAttribute('aria-controls');

        this.tabs.forEach((t) => {
          const active = t === tab;
          t.setAttribute('aria-selected', String(active));
          t.tabIndex = active ? 0 : -1;
        });

        this.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
          const show = panel.id === panelId;
          if (show && panel.hidden) {
            panel.hidden = false;
            panel.classList.add('is-entering');
            panel.addEventListener('animationend', () => panel.classList.remove('is-entering'), { once: true });
          } else if (!show) {
            panel.hidden = true;
          }
        });

        // Centra la scheda attiva nella barra scorrevole (mobile)
        const bar = tab.parentElement;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        bar.scrollTo({
          left: tab.offsetLeft - (bar.clientWidth - tab.offsetWidth) / 2,
          behavior: instant || reduce ? 'auto' : 'smooth',
        });

        if (focus) tab.focus();
      }

      onKeydown(event) {
        const tab = event.target.closest('[role="tab"]');
        if (!tab) return;

        const tabs = this.tabs;
        let index = tabs.indexOf(tab);

        switch (event.key) {
          case 'ArrowRight': index = (index + 1) % tabs.length; break;
          case 'ArrowLeft': index = (index - 1 + tabs.length) % tabs.length; break;
          case 'Home': index = 0; break;
          case 'End': index = tabs.length - 1; break;
          default: return;
        }

        event.preventDefault();
        this.select(tabs[index], { focus: true });
      }
    }

    customElements.define('collection-tabs', CollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
